import React from 'react';
import PropTypes from 'prop-types';
import { connect, getIn } from 'formik';
import { isEqual } from 'lodash';

import { withStyles } from '~/assets/withStyles';
import FormControl from '~/components/core/Atomic/FormControl';
import FormControlLabel from '~/components/core/Atomic/FormControlLabel';
import Radio, { SIZES as RADIO_SIZES } from '~/components/ui/atoms/Radio';

import styles from '../assets/styles';

const RadioButtonFormik = (props) => {
  const {
    formik,
    id,
    name = id,
    label,
    labelClassName,
    optionValue,
    onClick,
    disabled,
    onChange,
    showOnly,
    size,
    buttonClassName,
  } = props;

  const { values, setFieldValue } = formik;

  return (
    <FormControl>
      <FormControlLabel
        value=""
        disabled={showOnly || disabled}
        control={
          <Radio
            onClick={(e) => onClick && onClick(e)}
            name={name}
            checked={isEqual(getIn(values, id), optionValue)}
            onChange={() => (onChange ? onChange(id, optionValue) : setFieldValue(id, optionValue))}
            disabled={showOnly || disabled}
            // `small` is this wrapper's name for the Radio's 15px size, `xs`.
            size={size === 'small' ? RADIO_SIZES.xs : RADIO_SIZES.medium}
            className={buttonClassName}
          />
        }
        className={labelClassName}
        label={label}
        labelPlacement="end"
      />
    </FormControl>
  );
};

RadioButtonFormik.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  label: PropTypes.any.isRequired,
  optionValue: PropTypes.any.isRequired,
  labelClassName: PropTypes.string,
  buttonClassName: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  showOnly: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
  formik: PropTypes.object,
  onClick: PropTypes.func,
};

export default withStyles(connect(RadioButtonFormik), styles);
